<template>
    <div id="main">
      <div class="main-wrapper">
        <div class="poster-pc">
          <div class="main-title"></div>
          <div class="main-cake"></div>
          <div class="main-dish"></div>
          <div class="main-flower main-flower-left"></div>
          <div class="main-flower main-flower-right"></div>
          <div class="main-boom main-boom-center"></div>
          <div class="main-boom main-boom-left"></div>
          <div class="main-boom main-boom-right"></div>
          <div class="main-glow"></div>
        </div>
        <!-- <img class="poster-mobile" src="../assets/poster_mobile.png" alt=""> -->
      </div>
    </div>
</template>

<script>
import anime from 'animejs'

export default {
  data(){
    return {
    }
  },
  methods: {
  },
  mounted() {
    // 타이틀
    anime({
      targets: '.main-title',
      scale: 2,
      opacity: 1,
      duration: 1000,
      easing: "easeOutExpo",
    })

    // 케이크
    anime({
      targets: '.main-cake',
      scale: 2,
      opacity: 1,
      duration: 800,
      easing: "easeOutExpo",
      delay: 700,
    })

    // 그릇
    anime({
      targets: '.main-dish',
      translateY: -200,
      opacity: 1,
      duration: 1300,
      easing: "easeOutExpo",
      delay: 700,
    })

    // 꽃
    anime({
      targets: '.main-flower-left',
      translateX: 400,
      opacity: 1,
      duration: 1300,
      easing: "easeOutExpo",
      delay: 900,
    })
    anime({
      targets: '.main-flower-right',
      translateX: -400,
      opacity: 1,
      duration: 1300,
      easing: "easeOutExpo",
      delay: 1000,
    })

    // 터짐
    anime({
      targets: '.main-boom-left',
      translateY: -300,
      translateX: -120,
      scale: 4,
      opacity: 1,
      duration: 700,
      delay: 1100,
      easing: "easeOutExpo",
    })
    anime({
      targets: '.main-boom-right',
      translateY: 300,
      translateX: 120,
      rotate: '25deg',
      scale: 4,
      opacity: 1,
      duration: 700,
      delay: 1100,
      easing: "easeOutExpo",
    })
    anime({
      targets: '.main-boom-center',
      rotate: '25deg',
      scale: 4,
      opacity: 1,
      duration: 700,
      easing: "easeOutExpo",
    })

    // 반짝이
    anime({
      targets: '.main-glow',
      scale: 2,
      opacity: 1,
      duration: 3600,
      delay: 2000,
      easing: "easeOutExpo",
    })
  }
}
</script>

<style scoped>
@media all and (max-width: 767px) {
  .main-wrapper {
    width: 100vw;
    height: 100vh;
    min-height: 812px;
  }
  .main-container {
    width: 96vw;
    height: 100vh;
    min-height: 812px;
    color: #fff;
  }

  /* 포스터이미지 */
  .poster-pc {
    width: 100vw;
    text-align: center;
  }
  .poster-pc div {
    background-size: contain;
    background-repeat: no-repeat;
    position: fixed;
    opacity: 0;
  }

  /* 타이틀 */
  .main-title {
    width: 30vw;
    height: 26vw;
    top: 74vw;
    left: calc(50% - 12vw);
    z-index: 102;
    background: url('../assets/main/main-title.svg');
  }

  /* 케잌 */
  .main-cake {
    width: 48vw;
    height: 50vw;
    top: 50vw;
    left: calc(50% - 24vw);
    z-index: 100;
    background: url('../assets/main/main-cake.svg');
  }

  /* 그릇 */
  .main-dish {
    width: 120vw;
    height: 42vw;
    top: 173vw;
    left: calc(50% - 60vw);
    z-index: 99;
    background: url('../assets/main/main-dish.svg');
  }

  /* 화환 */
  .main-flower {
    display: none;
  }

  /* 터짐 */
  .main-boom {
    z-index: 110;
  }
  .main-boom-center {
    display: none;
  }
  .main-boom-left {
    display: none;
  }
  .main-boom-right {
    display: none;
  }

  /* 반짝이 */
  .main-glow {
    width: 120vw;
    height: 58vw;
    top: 40vw;
    left: calc(50% - 52vw);
    z-index: 90;
    background: url('../assets/main/main-glow.png');

  }


  /* 모바일 */
  .poster-mobile {
    display: none;
  }
}
@media all and (min-width: 768px) {
  .main-wrapper {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }
  .main-container {
    width: 96vw;
    height: 100vh;
    color: #fff;
  }

  /* 포스터이미지 */
  .poster-pc {
    width: 100vw;
    height: 100vh;
    text-align: center;
  }
  .poster-pc div {
    background-size: contain;
    background-repeat: no-repeat;
    position: fixed;
    opacity: 0;
  }

  /* 타이틀 */
  .main-title {
    width: 11vw;
    height: 10vw;
    top: 23vw;
    left: 46vw;
    z-index: 101;
    background: url('../assets/main/main-title.svg');
  }

  /* 케잌 */
  .main-cake {
    width: 17vw;
    height: 18vw;
    top: 15vw;
    left: 41.5vw;
    z-index: 100;
    background: url('../assets/main/main-cake.svg');
  }

  /* 그릇 */
  .main-dish {
    width: 34vw;
    height: 11.5vw;
    top: 50.5vw;
    left: 33vw;
    z-index: 99;
    background: url('../assets/main/main-dish.svg');
  }

  /* 화환 */
  .main-flower {
    width: 28.5vw;
    height: 47vw;
    z-index: 90;
    top: 5vw;
    background: url('../assets/main/main-flower.svg');
  }
  .main-flower-left {
    left: -12vw;
  }
  .main-flower-right {
    right: -13.2vw;
  }

  /* 터짐 */
  .main-boom {
    z-index: 110;
  }
  .main-boom-center {
    width: 10.3vw;
    height: 10.3vw;
    top: 21vw;
    left: 45vw;
    background: url('../assets/main/main-boom-center.svg');
  }
  .main-boom-left {
    width: 4.7vw;
    height: 10.5vw;
    top: 38.5vw;
    left: 21vw;
    background: url('../assets/main/main-boom-left.svg');
  }
  .main-boom-right {
    width: 5.2vw;
    height: 9.9vw;
    top: 9vw;
    right: 17vw;
    background: url('../assets/main/main-boom-right.svg');
  }

  /* 반짝이 */
  .main-glow {
    width: 43vw;
    height: 22.5vw;
    top: 17vw;
    left: 28.5vw;
    z-index: 130;
    background: url('../assets/main/main-glow.png');

  }

  .poster-web {
    width: 90vw;
    position: fixed;
    z-index: 99999999999;
    opacity: 0.3;
    left: calc( 50% - 45vw );
    top: 92px;
  }
  /* 모바일 */
  .poster-mobile {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/AppMain.vue